<script setup>
import draggable from 'vuedraggable';
import { generateHTML } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import { computed, watch } from 'vue';

const { question, disabled } = defineProps({ question: Object, disabled: Boolean });
const modelValue = defineModel();

const dragOptions = computed(() => ({
    animation: 200,
    group: 'description',
    disabled: false,
    ghostClass: 'ghost',
}));

watch(
    () => question.answers,
    (newAnswers) => {
        modelValue.value = newAnswers.map((a) => a.id);
    },
    { immediate: true, deep: true }
);
</script>
<template>
    <draggable v-model="question.answers" item-key="id" :scroll-sensitivity="200" :force-fallback="true" v-bind="dragOptions" handle=".drag-handler" class="answer-variants" :disabled="disabled">
        <template #item="{ element }">
            <div
                class="answer-variant"
                :class="{
                    disabled: disabled,
                    correct: element.isCorrect,
                    incorrect: element.isCorrect == false,
                }"
            >
                <div v-html="generateHTML(element.content, [StarterKit])"></div>
                <Button icon="pi pi-arrows-alt" variant="text" class="drag-handler" />
            </div>
        </template>
    </draggable>
</template>

<style scoped>
.answer-variants {
    @apply flex flex-col gap-6;
}
.answer-variant {
    @apply w-full p-4 border border-gray-200 rounded-xl flex items-center gap-4 justify-between bg-white;
}
.answer-variant.disabled {
    @apply bg-gray-100 pointer-events-none;
}
.answer-variant.correct {
    @apply bg-green-100;
}
.answer-variant.incorrect {
    @apply bg-red-100;
}
.drag-handler {
    @apply cursor-pointer hover:bg-gray-50 transition duration-300;
}
</style>
